var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43481 0.690995C7.73416 -0.230315 9.03757 -0.230313 9.33692 0.690997L10.631 4.67378C10.7649 5.0858 11.1488 5.36476 11.5821 5.36476H15.7698C16.7385 5.36476 17.1413 6.60437 16.3576 7.17378L12.9696 9.63527C12.6191 9.88991 12.4725 10.3413 12.6064 10.7533L13.9004 14.7361C14.1998 15.6574 13.1453 16.4235 12.3616 15.8541L8.97365 13.3926C8.62316 13.138 8.14857 13.138 7.79808 13.3926L4.41012 15.8541C3.62641 16.4235 2.57193 15.6574 2.87128 14.7361L4.16537 10.7533C4.29924 10.3413 4.15258 9.88991 3.80209 9.63527L0.414139 7.17377C-0.369575 6.60437 0.0332026 5.36476 1.00193 5.36476H5.18967C5.62289 5.36476 6.00685 5.0858 6.14072 4.67378L7.43481 0.690995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.822a5767fd2ff25ba5c1aa60d9466fd5.svg";
export { ForwardRef as ReactComponent };